import type { SearchFilterType } from '@/scopes/search/search/infrastructure/api/types';

export const DEFAULT_RESULTS_PER_PAGE = 10;
export const DEFAULT_SORTING_BY = 'Popularity';

export const COMPULSORY_FILTER_TYPES: SearchFilterType[] = ['TransportType', 'Participants', 'Duration'];
